<template>
  <div v-if="surveyData">
    <div class="mdc-card  mgb-24 pdt-24 pdb-8 pdl-24 pdr-24">
    <div class="t-headline7 font-m  mgb-16">{{ $t("698") }}</div>
    <div class="pdt-16 pdb-16">
        <div class="d-flex">
            <div class="t-subtitle2 font-b p-24 bg-iconInactive t-color-white w-24 h-24 d-flex justify-content-center align-items-center b-radius50">
              P
            </div>
            <div class="t-body1 font-r t-color-bodyGrayA pdl-16 l-spacing48 flex-grow-1">
              {{ $t("699") }}
            </div>
            <div class="t-body1 font-r">{{ $t("701", { str: $n(surveyData.point.closeEarnPoint) }) }}</div>
        </div>
    </div>
    <div class="pdt-16 pdb-16">
        <div class="d-flex">
            <div
                class="t-subtitle2 font-b p-24 bg-iconInactive t-color-white w-24 h-24 d-flex justify-content-center align-items-center b-radius50">
                P</div>
            <div class="t-body1 font-r t-color-bodyGrayA pdl-16 l-spacing48 flex-grow-1">{{ $t("700") }}
            </div>
            <div class="t-body1 font-r">{{ $t("701", { str: $n(surveyData.point.responseAllEarnPoint) }) }}</div>
        </div>
    </div>

</div>

<div class="mdc-card  mgb-50 pdt-24 pdb-8 pdl-24 pdr-24"  v-if="badgesData.length">
    <div class="t-headline7 font-m  mgb-16">{{ $t("1015") }}</div>
    <div class="pdt-10 pdb-10 d-flex align-items-center" v-for="(badge, index) in badgesData"
          :key="index">
        <img :src="badge.image" alt="" v-if="badge.image" class="icon56" />
        <div class="t-body1 font-r t-color-botyGrayA l-spacing48 pdl-20">
            {{ badge.name }}
        </div>
    </div>
</div>
  </div>
</template>

<script>
export default {
  props: ["surveyData", "badgesData"],
};
</script>

<style>
</style>